export enum ResourceMimeType {
  // Documents
  pdf = 'application/pdf',
  // Word
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  docm = 'application/vnd.ms-word.document.macroenabled.12',
  dotx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  dotm = 'application/vnd.ms-word.template.macroenabled.12',
  // Excel
  xls = 'application/vnd.ms-excel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlsm = 'application/vnd.ms-excel.sheet.macroenabled.12',
  xlsb = 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
  xltx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  xltm = 'application/vnd.ms-excel.template.macroenabled.12',
  // PowerPoint
  ppt = 'application/vnd.ms-powerpoint',
  pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  pptm = 'application/vnd.ms-powerpoint.presentation.macroenabled.12',
  potx = 'application/vnd.openxmlformats-officedocument.presentationml.template',
  ppsx = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  // OpenDocument
  odt = 'application/vnd.oasis.opendocument.text',
  ods = 'application/vnd.oasis.opendocument.spreadsheet',
  odp = 'application/vnd.oasis.opendocument.presentation',
  // Text
  csv = 'text/csv',
  md = 'text/markdown',
  plain = 'text/plain',
  eml = 'message/rfc822',
  // Archives
  zip = 'application/zip',
  rar = 'application/x-rar-compressed',
  bz2 = 'application/x-bzip2',
  bz = 'application/x-bzip',
  arc = 'application/octet-stream',
  // Images
  jpeg = 'image/jpeg',
  png = 'image/png',
  ico = 'image/x-icon',
  svg = 'image/svg+xml',
  gif = 'image/gif',
  webp = 'image/webp',
  bmp = 'image/bmp',
  // Video
  mp4 = 'video/mp4',
  mov = 'video/quicktime',
  avi = 'video/x-msvideo',
  webm = 'video/webm',
  mpeg = 'video/mpeg',
  m4v = 'video/x-m4v',
  ogg = 'video/ogg',
}

/**
 * Extension aliases that map to existing MIME types.
 * Key: extension, Value: ResourceMimeType key it maps to
 */
export const extensionAliases: Record<string, keyof typeof ResourceMimeType> = {
  jpg: 'jpeg',
  txt: 'plain',
};

export const supportedNonStandardExtensions = ['edi'];

export const ignoredExtensions = ['ini'];
